import * as React from 'react';

import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { plural } from '@cian/utils/lib/shared/plural';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { INewObject } from '../../types';
import { Link } from '../../common/components/link';
import { isArrayWithItems } from '../../utils';
import { getFilteredRoomsInfo } from './helpers';
import * as styles from './index.css';
import { RoomInfo } from './item';
import { FOfferType, getOfferType, isCommercial } from '../../utils/offer_type';

import * as Analytics from './tracking';
import { NewbuildingFeatures } from '../newbuilding_features';

export interface INewObjectStatsProps {
  newObject: INewObject | null;
  offer: IOfferSchema;
  isABNewbuildingFeaturesExperimentEnabled: boolean;
}

export class NewObjectStats extends React.PureComponent<INewObjectStatsProps, {}> {
  public render() {
    const { newObject, isABNewbuildingFeaturesExperimentEnabled, offer } = this.props;

    if (!newObject || !isArrayWithItems(newObject.roomsInfo)) {
      return null;
    }

    const offerType = getOfferType(offer);
    const isNewBuilding = offerType === FOfferType.FlatNew;
    const firstNewBuildingImage =
      isABNewbuildingFeaturesExperimentEnabled &&
      isNewBuilding &&
      newObject.newbuildingFeatures &&
      newObject.newbuildingFeatures.firstImageUrl;

    const isCommercialCardWithJK =
      isCommercial(offerType) &&
      [FOfferType.FreeAppointmentObject, FOfferType.Office, FOfferType.TradeArea, FOfferType.Warehouse].includes(
        offerType,
      );

    const jkTitle = isCommercialCardWithJK ? (
      <>{renderName(newObject, true)}</>
    ) : (
      <>Ещё квартиры {renderName(newObject)}</>
    );

    return (
      <section className={styles['container']}>
        <div className={styles['description']}>
          <h3 className={styles['title']}>{jkTitle}</h3>
          {renderSubTitle(newObject)}
          {newObject.developer && newObject.developer.logoUrl && (
            <div className={styles['logo']}>
              <img src={firstNewBuildingImage || newObject.developer.logoUrl} />
            </div>
          )}
          {isNewBuilding && (
            <NewbuildingFeatures
              newObject={newObject}
              isABNewbuildingFeaturesExperimentEnabled={isABNewbuildingFeaturesExperimentEnabled}
            />
          )}
        </div>
        <ul className={styles['rooms']}>
          {getFilteredRoomsInfo(newObject.roomsInfo, this.props.offer).map((item, index) => (
            <RoomInfo key={index} info={item} />
          ))}
        </ul>
      </section>
    );
  }
}

function renderName(newObject: INewObject, isCommercialCardWithJK?: boolean) {
  const newObjectUrl = newObject.fullUrlWithSubdomain || newObject.url;

  if (newObjectUrl) {
    return (
      <Link
        className={styles['title-link']}
        href={newObjectUrl}
        target="_blank"
        rel="nofollow noopener"
        onClick={() => Analytics.trackClickJK('jk')}
      >
        {isCommercialCardWithJK ? '' : 'в '}ЖК &laquo;{newObject.name}&raquo;
      </Link>
    );
  }

  return <span>в {newObject.name}</span>;
}

function renderSubTitle(newObject: INewObject) {
  const { totalCountOfferInNewobject: total, status } = newObject;
  let subtitle: string[] = [];

  if (total) {
    subtitle.push(`${numberToPrettyString(total)} ${plural(total, ['квартира', 'квартиры', 'квартир'])} в продаже`);
  }

  if (status) {
    subtitle.push(status);
  }

  return <div className={styles['subtitle']}>{subtitle.join(' · ')}</div>;
}
